import { render, staticRenderFns } from "./MySailinkView.vue?vue&type=template&id=48cebf31&"
import script from "./MySailinkView.vue?vue&type=script&lang=js&"
export * from "./MySailinkView.vue?vue&type=script&lang=js&"
import style0 from "./MySailinkView.vue?vue&type=style&index=0&id=48cebf31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports